<template>
	<RightPane
		v-bind:display="display"
		v-bind:persistent="is_showpicker"
		v-on:close="onClose"
	>
		<Dialog
			:dialog="dialog" 
			@agree="onClickAgree"
			@disagree="onClickDisagree"
		/>
		<ModalVScrollable class="task-info"
			title="タスク情報"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
		>
			<template v-slot:header v-if="value && isEditable">
				<div class="modal-header-task-info">
					<v-btn flat blue large color="white" v-on:click="onClickDone">完了</v-btn>
					<v-btn flat blue large color="white" v-on:click="onClickDelete">削除</v-btn>
				</div>
			</template>
			<template v-if="value">
				<v-layout wrap mt-3 mb-3 mx-2 pr-2>
					<v-flex xs2 v-bind:class="classNameLabel" v-bind:style="styleTextfieldLabel">
						名前
					</v-flex>
					<v-flex xs10 class="content-name">
						<template v-if="isEditable">
							<v-text-field
								v-model=value.task.name
								maxlength="40"
								:rules="[rules.required, rules.name_length]"
								counter
							></v-text-field>
						</template>
						<template v-else>
							{{ value.task.name}}
						</template>
					</v-flex>
				</v-layout>
				<v-layout wrap mx-2 pr-2><!-- スケジュールリスト -->
					<RightPaneTaskScheduleList v-for="schedule in value.task.schedules" 
						:key="schedule.code" 
						v-bind:schedule="schedule"
						v-bind:isPositionLast="util.isPositionLast(value.task.schedules, schedule)"
						v-bind:deletable="value.task.schedules.length > 1"
						v-bind:isEditable="isEditable"
						v-on:on-change-picker-state="changePickerState"
						v-on:add-schedule="AddSchedule"
						v-on:delete-schedule="DeleteSchedule"
					/>
				</v-layout>	<!-- スケジュールリスト -->
				<v-layout wrap mx-2 mb-2 mt-2 pr-2>
					<template v-if="!isDisplayTypeMember">
						<v-flex xs2 class="label select-member-label">
							メンバー
						</v-flex>
						<v-flex xs10 class="content">
							<template v-if="isEditable">
								<v-layout v-if="value.task.member_code != ''">
									<v-flex xs10>
										<v-btn flat small class="blue--text subheading select-member" v-on:click="showRightPaneMemberList" >
											<div class="text-truncate">
												{{ memberName }}
											</div>
										</v-btn>
									</v-flex>
									<v-flex xs2>
										<v-btn small flat fab class="unselect-icon" v-on:click="onUnselectMember"><v-icon>close</v-icon></v-btn>
									</v-flex>
								</v-layout>
								<v-btn flat small class="blue--text subheading select-member" v-on:click="showRightPaneMemberList" v-else>選択なし</v-btn>
							</template>
							<template v-else>
								{{ memberName }}
							</template>
						</v-flex>
					</template>
					<template v-else>
						<v-flex xs2 class="label">
							案件
						</v-flex>
						<v-flex xs10 class="content">
							<template v-if="isEditable">
								<v-layout wrap v-if="value.task.project_code !=''">
									<v-flex xs10>
										<v-btn flat small class="blue--text subheading select-project" v-on:click="showRightPaneProjectList">
											<div class="text-truncate">
												{{ projectName }}
											</div>
										</v-btn>
									</v-flex>
									<v-flex xs2>
										<v-btn small flat fab class="unselect-icon" v-on:click="onUnselectProject"><v-icon>close</v-icon></v-btn>
									</v-flex>
								</v-layout>
								<v-btn flat small class="blue--text subheading select-project" v-on:click="showRightPaneProjectList" v-else>選択なし</v-btn>
							</template>
							<template v-else>
								{{ projectName }}
							</template>
						</v-flex>
					</template>
				</v-layout>
				<v-layout wrap mx-2 pr-2>
					<v-flex xs-12  pt-3 style="border-top: 1px solid lightgray;">
						<v-layout>
							<v-flex xs2 d-flex align-start class="multi-line-label">
								備考
							</v-flex>
							<v-flex xs10 class="content">
								<template v-if="isEditable">
									<v-textarea
										v-model=value.task.remarks
										outline
										maxlength="100"
										:rules="[rules.remarks_length]"
										counter
									></v-textarea>
								</template>
								<template v-else>
									{{ value.task.remarks }}
								</template>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout row class="modal-header-filter">
				</v-layout>
			</template>
		</ModalVScrollable>
	</RightPane>
</template>
<script>


import RightPane from './RightPane';
import ModalVScrollable from './ModalVScrollable';
import RightPaneTaskScheduleList from './RightPaneTaskScheduleList.vue';
import Dialog from './Dialog';


import { DISPLAY_LIST_TYPE, FORM_MODE, LIST_MODE} from '../classes/Const';
import Util from '../classes/Util';
import Schedule from '../classes/Schedule';

const validateLengthName = function(value) {
	if(value.length <= 40)
		return true;
	return false;
};

const validateLengthRemarks = function(value) {
	if(value.length <= 100)
		return true;
	return false;
};

export default {
	name: 'RightPaneTaskInfo',
	props: [
		'value',
	],
	components: {
		RightPane,
		ModalVScrollable,
		RightPaneTaskScheduleList,
		Dialog,
	},
	data: function() {
		return {
			rules: {
				required: v => !!v || '入力してください',
				name_length: v => validateLengthName(v) || '40文字以内で入力してください',
				remarks_length: v => validateLengthRemarks(v) || '100文字以内で入力してください',
			},
			dialog: {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			},
			util:Util,
			is_showpicker : false,
		}
	},
	methods: {
		onUnselectProject: function(){
			this.value.task.project_code = "";
		},
		onUnselectMember: function(){
			this.value.task.member_code = "";
		},
		DeleteSchedule: function(schedule){
			if(schedule){
				Util.array_remove(this.value.task.schedules, schedule);
			}else{
				return;
			}
		},
		AddSchedule: function(){
			let s = this.createNewSchedule();
			this.value.task.schedules.push(s);
		},
		changePickerState:function(e){
			this.is_showpicker = e.isShow;
		},
		onClose: function() {
			this.$emit('close');
		},
		onClickDone: function(){
			//error
			if(!this.value.task.name){
				this.displayErrorDialog('未入力の項目があります');
				return;
			}else if(!validateLengthName(this.value.task.name)){
				this.displayErrorDialog('名前は40文字以内で入力してください');
				return;
			}else if(!validateLengthRemarks(this.value.task.remarks)){
				this.displayErrorDialog('備考は100文字以内で入力してください');
				return;
			}

			this.value.task.is_updated = true;
			this.value.task.schedules.forEach( s => {
				s.member_code = this.value.task.member_code;
				s.project_code = this.value.task.project_code;
			});
			this.$emit("update-task", this.value.task);
			this.onClose();
		},
		onClickDelete: function(){
			const agree = () => {
				this.dialog.display = false;
				this.$emit("delete-task", this.value.task.code);
				this.dialog.agree = null;
				this.onClose();
			};
			this.displayConfirmationDialog('タスクを削除しますが、よろしいでしょうか', agree);
		},
		showRightPaneMemberList:function(){
			this.$emit("show-rightpane-memberlist", {
				member_code: this.value.task.member_code,
				mode: LIST_MODE.SELECT,
			});
		},
		showRightPaneProjectList:function(){
			this.$emit("show-rightpane-projectlist", {
				project_code: this.value.task.project_code,
				mode: LIST_MODE.SELECT,
			});
		},
		createNewSchedule: function() {
			let task_code = this.value.task.code;
			let project_code = this.value.project_code;
			let member_code = this.value.task.member_code;
			
			return new Schedule.defaultSchedule({
				project_code: project_code,
				member_code: member_code,
				task_code: task_code,
				date: this.$store.getters.currentDate,
			})
		},
		displayErrorDialog: function(text) {
			this.dialog.title = 'エラー';
			this.dialog.text = text;
			this.dialog.disagree = null;
			this.dialog.agree = () => {
				this.dialog.display = false;
				this.dialog.agree = null;
			};
			this.dialog.display = true;
		},
		displayConfirmationDialog: function(text, agree) {
			this.dialog.title = '確認';
			this.dialog.text = text;
			this.dialog.disagree = () => {
				this.dialog.display = false;
			};
			this.dialog.agree = agree;
			this.dialog.display = true;
		},
		onClickDisagree: function() {
			if (this.dialog.disagree)
				this.dialog.disagree();
			return;
		},
		onClickAgree: function() {
			if (this.dialog.agree)
				this.dialog.agree();
			return;
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		classNameLabel: function() {
			if(this.isEditable)
				return ['label'];
			else
				return ['multi-line-label'];
		},
		memberName: function() {
			if (this.value.task.member_code == null)
				return "選択なし" ;
			let member = this.$store.getters['member'](this.value.task.member_code);
			if (member){
				return member.name;
			} else{
				return "選択なし" ;
			}
		},
		projectName: function() {
			if (this.value.task.project_code == null)
				return "選択なし";
			let project = this.$store.getters['project'](this.value.task.project_code);
			if (project){
				return project.name;
			} else{
				return "選択なし" ;
			}
		},
		isEditable: function() {
			return this.value.mode !== FORM_MODE.REFERENCE;
		},
		isDisplayTypeMember: function() {
			return this.value.display_type === DISPLAY_LIST_TYPE.MEMBER;
		},
		styleTextfieldLabel: function(){
			if(this.isEditable)
				return {"margin-top" : -4 + "px"};
			else
				return "";
		},
	},
	watch: {
	},
}
</script>
<style>
	.task-info .select-member .v-btn__content,.select-project .v-btn__content{
		max-width: 220px;
	}
	.task-info.modal-window .unselect-icon{
		margin: 0;
		margin-left: 1.4rem;
		height: 24px;
		width: 24px;
	}
	.task-info.modal-window .label {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 16px;
	}
	.task-info .select-member-label{
		font-size: .85rem !important;
	}
	.task-info.modal-window .multi-line-label {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		font-size: 16px;
	}
	.task-info.modal-window .content {
		display: flex;
		align-items: flex-start;
		font-size: 16px;
	}
	.task-info.modal-window .content-name {
		word-wrap: break-word;
		font-size: 16px;
	}
	.task-info.modal-window .modal-header-task-info {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.task-info .select-project,.select-member{
		margin:0;
		padding: 0;
	}
</style>